/**
 * ปิด Bootstrap offcanvas ให้เรียบร้อยก่อน route ออกจากหน้าที่มันอยู่
 *
 * offcanvas ที่เปิดด้วย data-bs-toggle จะถูก Bootstrap ล็อก scroll ของ body
 * (`overflow: hidden` + padding ชดเชย scrollbar) และแปะ `.offcanvas-backdrop`
 * ไว้ใต้ <body>. ถ้า router พาไปหน้าอื่นตอน offcanvas ยังเปิดอยู่ component จะ
 * ถูก unmount ไปเฉย ๆ โดยที่ hide() ของ Bootstrap ไม่เคยถูกเรียก → ทั้ง scroll
 * lock และ backdrop ค้างอยู่กับหน้าใหม่ (มือถือจะเลื่อนหน้าไม่ได้เลย)
 *
 * @param {string|HTMLElement} target id (ไม่ต้องมี #) หรือ element ของ offcanvas
 * @returns {Promise<void>} resolve เมื่อ Bootstrap ซ่อนเสร็จ (หรือไม่มีอะไรต้องซ่อน)
 */
export function dismissOffcanvas(target) {
  const el = typeof target === 'string' ? document.getElementById(target) : target;
  const instance = el && window.bootstrap?.Offcanvas?.getInstance(el);

  // ไม่มี instance = ไม่เคยเปิด (เช่น จอ lg ที่ offcanvas-lg เป็น panel ปกติ)
  if (!instance || !el.classList.contains('show')) return Promise.resolve();

  return new Promise(resolve => {
    el.addEventListener('hidden.bs.offcanvas', () => resolve(), { once: true });
    // กันเหนียว เผื่อ transitionend ไม่ยิง (element ถูกซ่อน/ย้ายระหว่างทาง)
    setTimeout(resolve, 400);
    instance.hide();
  });
}
